// 引入axios
import axios from "axios";

let host = window.location.origin;
let instance = axios.create({
    // baseURL: process.env.VUE_APP_BASE_URL,
    baseURL: host,
    timeout: 60000
});
// instance.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";

// 添加请求拦截器
instance.interceptors.request.use(function(config) {
    const token = sessionStorage.getItem("webToken");
    if (token) {
        config.headers.Authorization = token;
    }
    return config;
}, function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use(function(response) {
    return response.data;
}, function(error) {
    return Promise.reject(error);
});

export default instance;
